import React from 'react';
import pipes from '../assets/Pipes.jpg';
import './Home.css';
import InstructionPopup from './InstructionPopup';
import { Link } from 'react-router-dom';
import { FACEBOOK_URL } from '../utils/constants';

function Home() {
  const handleResetPopups = () => {
    InstructionPopup.resetAllPopups();
  };

  const handleFacebookClick = () => {
    window.open(FACEBOOK_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="app-theme home-theme">
      <InstructionPopup
        id="home-welcome"
        title="Welcome to Bagpipe Blasphemy"
        message="Welcome! Each feature has a simple introductory message to help you get started. Feel free to hide these if you never want to see them again."
        buttonText="Got it!"
      />
      <h1>Welcome to Bagpipe Blasphemy</h1>
      <p>Where technology meets tradition!</p>
      <button className="facebook-follow-button" onClick={handleFacebookClick}>
        Follow us on Facebook
      </button>
      <div className="logo-container">
        <img
          src={pipes}
          className="main-logo"
          alt="Pipes Logo"
          onError={e => {
            console.error('Error loading image:', e);
            e.target.style.display = 'none';
          }}
        />
        <button className="reset-popups-button" onClick={handleResetPopups}>
          Show All One Time Messages
        </button>
      </div>

      <div className="content-section">
        <h2>Welcome to BagpipeBlasphemy</h2>
        
        <div className="content-intro">
          <p>
            BagpipeBlasphemy makes learning Highland bagpipes fun and accessible for beginners and advanced pipers. Our interactive lessons, games like Note Blaster and Bagpipe Battle, and tools like ChanterSync and our bagpipe tuner help you master Scottish music. Whether you're starting your bagpipe journey or refining your pipe band skills, our platform offers expert tutorials, precision tuning, and community leaderboards to track your progress.
          </p>
        </div>

        <div className="features-section">
          <h3>Why Learn with Us?</h3>
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">🎓</div>
              <div className="feature-title">Interactive Lessons</div>
              <div className="feature-description">Master bagpipe techniques with step-by-step tutorials.</div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🎮</div>
              <div className="feature-title">Fun Games</div>
              <div className="feature-description">Improve note recognition with Note Blaster and Bagpipe Battle.</div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🎵</div>
              <div className="feature-title">Precision Tools</div>
              <div className="feature-description">Tune your chanter with our professional bagpipe tuner.</div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🗺️</div>
              <div className="feature-title">Professional Instruction</div>
              <div className="feature-description">Learn from pipers near you. Find them on a map of your area!</div>
            </div>
          </div>
        </div>

        <div className="cta-section">
          <p>
            Start your bagpipe journey today! Explore our games, and tools to become a skilled piper with BagpipeBlasphemy.
          </p>
        </div>
      </div>

      <div className="feature-grid">
        {/* ... existing code ... */}
      </div>
    </div>
  );
}

export default Home;
